import React, { Component, CSSProperties } from 'react';

import { ImgLayout } from './../index'

interface IImgComponentProps {
    src: string
    style?: CSSProperties
    className?: string
    width?: string
    height?: string
    alt?: string
    onClick?: ()=>void
}

interface IImgComponentState {}

class ImgComponent extends Component<IImgComponentProps, IImgComponentState> {

    constructor(props: IImgComponentProps){
        super(props)
    }

    render() {
        return (
            <ImgLayout
                {...this.props}
            />
        );
    }
}

export default ImgComponent;